import { useEffect, useState } from 'react'

export const useMounted = (): boolean => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return mounted
}

export const useNow = (interval = 1000): number | null => {
    const [now, setNow] = useState<number | null>(null)

    useEffect(() => {
        setNow(Date.now())
        const timer = window.setInterval(() => setNow(Date.now()), interval)

        return () => window.clearInterval(timer)
    }, [interval])

    return now
}
